import React, { useState } from "react";
import ApiCustom from "../utils/ApiCustom";
import { toast } from "react-toastify";

const ForgotPasswordForm = ({ onBack, onOtpSent }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await ApiCustom.post(
        "/user-forgot-password",
        {
          userEmail: email,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        toast.success("Mã xác nhận đã được gửi đến email của bạn!");
        onOtpSent(email);
      }
    } catch (error) {
      toast.error(error.response?.data?.messages || "Có lỗi xảy ra!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-base-100 shadow-lg rounded-lg p-6 w-80">
      <h2 className="text-2xl font-bold text-center mb-4">Quên mật khẩu</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Nhập email đã đăng ký tài khoản"
            required
            disabled={loading}
          />
        </div>
        <div className="mb-2 text-[14px]">
          <span className="text-red-500">* </span>Mã xác thực sẽ được gửi về
          email của bạn. Vui lòng kiểm tra hộp thư!
        </div>
        <div className="flex justify-between">
          <button
            type="button"
            onClick={onBack}
            className="btn py-2 rounded-md transition duration-300 btn-sm"
            disabled={loading}
          >
            Quay lại
          </button>
          <button
            type="submit"
            className="btn btn-primary py-2 rounded-md transition duration-300 btn-sm"
            disabled={loading}
          >
            {loading ? "Đang gửi..." : "Tiếp theo"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ForgotPasswordForm;
